export const getUniqueVendors = (sites: Array<Record<string, any>>) => {
	const vendors = new Set<string>();

	for (let i = 0; i < sites.length; i++) {
		if (typeof sites[i].vendor === 'object') {
			vendors.add(sites[i].vendor.name);
		} else {
			vendors.add(sites[i].vendor);
		}
	}

	return Array.from(vendors);
};
